import { PlumeGradient } from "./types";

export function generatePlumeGradient(hexColor: string): PlumeGradient {
  // convert hex to RGB
  const hex = hexColor.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // define the concentration stops and their corresponding opacity values
  const stops = [
    { concentration: 2.5, opacity: 0.0 },
    { concentration: 3.5, opacity: 0.0 },
    { concentration: 4.5, opacity: 0.0 },
    { concentration: 5.5, opacity: 0.0 },
    { concentration: 7.0, opacity: 0.15 },
    { concentration: 8.5, opacity: 0.2 },
    { concentration: 10.0, opacity: 0.25 },
    { concentration: 12.0, opacity: 0.3 },
    { concentration: 14.0, opacity: 0.35 },
    { concentration: 16.0, opacity: 0.4 },
    { concentration: 20.0, opacity: 0.45 },
    { concentration: 25.0, opacity: 0.5 },
    { concentration: 30.0, opacity: 0.55 },
    { concentration: 40.0, opacity: 0.58 },
    { concentration: 50.0, opacity: 0.6 }
  ];

  // build the interpolation array
  const gradient: PlumeGradient = [
    "interpolate",
    ["linear"],
    ["get", "concentration"]
  ] as PlumeGradient;

  // add each stop as concentration value followed by rgba color
  stops.forEach((stop) => {
    gradient.push(stop.concentration);
    gradient.push(`rgba(${r}, ${g}, ${b}, ${stop.opacity.toFixed(2)})`);
  });

  return gradient;
}
